import { supabase } from './client'

export async function sendClinicalResultReadyEmail({
  email,
  patientName,
  providerName,
  serviceType,
  date,
  appointmentId,
}: {
  email: string
  patientName: string
  providerName: string
  serviceType: string
  date: string
  appointmentId: string
}): Promise<boolean> {
  try {
    const { error } = await supabase.functions.invoke('send-email', {
      body: {
        email,
        name: patientName,
        emailType: 'clinical-result-ready',
        data: {
          providerName,
          serviceType,
          date,
          patientWebUrl: `${window.location.origin}/patient/appointments/${appointmentId}`,
          patientAppUrl: `myapp://patient-appointment-details/${appointmentId}`,
        },
      },
    })

    if (error) {
      console.error('Failed to send clinical result email:', error)
      return false
    }

    return true
  } catch (error) {
    console.error('Clinical result email error:', error)
    return false
  }
}